import { render, staticRenderFns } from "./MessageComposer.vue?vue&type=template&id=215bdee5&scoped=true"
import script from "./MessageComposer.vue?vue&type=script&lang=js"
export * from "./MessageComposer.vue?vue&type=script&lang=js"
import style0 from "./MessageComposer.vue?vue&type=style&index=0&id=215bdee5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215bdee5",
  null
  
)

export default component.exports